import { deviceApi } from '@/redux/api/endpoints/device';
import { DispatchOptimisticPatchHandler } from '@/redux/types/dispatch-optimistic-patch-handler';
import { updateItemRecipe } from '@/redux/utils/update-item-recipe';
import { DeviceUnassociated } from '@/types/device';
import { RemoveDeviceFromOrganisationQueryArg } from '../types/query-arg';

export const dispatchOptimisticPatchRemoveDeviceFromOrganisation: DispatchOptimisticPatchHandler<
  RemoveDeviceFromOrganisationQueryArg
> = ({ device }, { dispatch }) => {
  const patch = dispatch(
    // Only Platform Admin should be able to call removeDeviceFromOrganisation so we don't need an organisationId passed to updateQueryData
    deviceApi.util.updateQueryData(
      'getUnassociatedDevices',
      {},
      updateItemRecipe<DeviceUnassociated, 'endpointId'>(
        'endpointId',
        device.endpointId,
        {
          organisation: undefined,
        },
      ),
    ),
  );

  return { patch };
};
